import { ProductConfiguration } from '@/shared/models/ContextDataModel/interfaces/entities/product-configuration.ts';
import {
    ADDITIONAL_SERVICE_PRODUCT_TYPE,
    ADDITIONAL_SERVICE_PRODUCT_TYPE_SCHEMA,
    ADDITIONAL_SERVICE_SUPPORTED_UNITS,
    ADDITIONAL_SERVICE_SUPPORTED_UNITS_SCHEMA,
} from '@schuettflix/interfaces';

export function isAdditionalServiceProduct<T extends ProductConfiguration>(
    product: T
): product is T & {
    productType: ADDITIONAL_SERVICE_PRODUCT_TYPE;
    partnerOrganizationId: number;
    salesUnit: ADDITIONAL_SERVICE_SUPPORTED_UNITS;
    purchaseUnit: ADDITIONAL_SERVICE_SUPPORTED_UNITS;
} {
    return (
        ADDITIONAL_SERVICE_PRODUCT_TYPE_SCHEMA.safeParse(product.productType).success &&
        ADDITIONAL_SERVICE_SUPPORTED_UNITS_SCHEMA.safeParse(product.salesUnit).success &&
        ADDITIONAL_SERVICE_SUPPORTED_UNITS_SCHEMA.safeParse(product.purchaseUnit).success &&
        product.partnerOrganizationId !== null
    );
}
